"use client";
import { useEffect, useState } from "react";
import { NextStep, NextStepProvider, Tour } from "nextstepjs";
import { CustomStepCard } from "./CustomStepCard";
import { useTalentPoolTour } from "./hooks/useTalentPoolTour";
import {
  onboardingStepsSelector,
  useOnboardingTour,
} from "./hooks/useOnboardingTour";
import { FeatureTour } from "./constant";
import { useJobTour } from "./hooks/useJobTour";
import { useFeatureTourStore } from "@/_stores/useFeatureTourStore";

interface FeatureTourProps {
  children: React.ReactNode;
}

export const FeatureTours = ({ children }: FeatureTourProps) => {
  const [isMounted, setIsMounted] = useState(false);
  const setAutoCreateJob = useFeatureTourStore((s) => s.setAutoCreateJob);
  const onboardingTour = useOnboardingTour({
    tour: FeatureTour.Onboarding,
    selectors: onboardingStepsSelector,
  });

  const talentPoolTour = useTalentPoolTour();

  const jobTour = useJobTour();

  const steps: Tour[] = [onboardingTour, talentPoolTour, jobTour];

  const onStepChange = (step: number, tourName: string | null) => {
    if (tourName === FeatureTour.JobManagement) {
      if (step === 3) {
        setAutoCreateJob(true);
      }
    }
  };

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return (
    <NextStepProvider>
      {isMounted ? (
        <NextStep
          steps={steps}
          cardComponent={CustomStepCard}
          displayArrow
          onStepChange={onStepChange}
        >
          {children}
        </NextStep>
      ) : (
        children
      )}
    </NextStepProvider>
  );
};
